var map = {
	"./editorBaseApi": [
		7932
	],
	"./editorBaseApi.js": [
		7932
	],
	"./editorSimpleWorker": [
		1208
	],
	"./editorSimpleWorker.js": [
		1208
	],
	"./editorWorker": [
		7122,
		792
	],
	"./editorWorker.js": [
		7122,
		792
	],
	"./editorWorkerHost": [
		7576
	],
	"./editorWorkerHost.js": [
		7576
	],
	"./findSectionHeaders": [
		1777
	],
	"./findSectionHeaders.js": [
		1777
	],
	"./getIconClasses": [
		7004,
		792
	],
	"./getIconClasses.js": [
		7004,
		792
	],
	"./languageFeatureDebounce": [
		981,
		792
	],
	"./languageFeatureDebounce.js": [
		981,
		792
	],
	"./languageFeatures": [
		4996,
		792
	],
	"./languageFeatures.js": [
		4996,
		792
	],
	"./languageFeaturesService": [
		4867,
		792
	],
	"./languageFeaturesService.js": [
		4867,
		792
	],
	"./languageService": [
		7201,
		792
	],
	"./languageService.js": [
		7201,
		792
	],
	"./languagesAssociations": [
		3994,
		792
	],
	"./languagesAssociations.js": [
		3994,
		792
	],
	"./languagesRegistry": [
		7653,
		792
	],
	"./languagesRegistry.js": [
		7653,
		792
	],
	"./markerDecorations": [
		3804,
		792
	],
	"./markerDecorations.js": [
		3804,
		792
	],
	"./markerDecorationsService": [
		4903,
		792
	],
	"./markerDecorationsService.js": [
		4903,
		792
	],
	"./model": [
		1220,
		792
	],
	"./model.js": [
		1220,
		792
	],
	"./modelService": [
		4371,
		792
	],
	"./modelService.js": [
		4371,
		792
	],
	"./resolverService": [
		1656,
		792
	],
	"./resolverService.js": [
		1656,
		792
	],
	"./semanticTokensDto": [
		9410,
		792
	],
	"./semanticTokensDto.js": [
		9410,
		792
	],
	"./semanticTokensProviderStyling": [
		4378,
		792
	],
	"./semanticTokensProviderStyling.js": [
		4378,
		792
	],
	"./semanticTokensStyling": [
		2629,
		792
	],
	"./semanticTokensStyling.js": [
		2629,
		792
	],
	"./semanticTokensStylingService": [
		7922,
		792
	],
	"./semanticTokensStylingService.js": [
		7922,
		792
	],
	"./textModelSync/textModelSync.impl": [
		3111
	],
	"./textModelSync/textModelSync.impl.js": [
		3111
	],
	"./textModelSync/textModelSync.protocol": [
		1310,
		792
	],
	"./textModelSync/textModelSync.protocol.js": [
		1310,
		792
	],
	"./textResourceConfiguration": [
		9182,
		792
	],
	"./textResourceConfiguration.js": [
		9182,
		792
	],
	"./treeSitterParserService": [
		2114,
		792
	],
	"./treeSitterParserService.js": [
		2114,
		792
	],
	"./treeViewsDnd": [
		7165,
		792
	],
	"./treeViewsDnd.js": [
		7165,
		792
	],
	"./treeViewsDndService": [
		2602,
		792
	],
	"./treeViewsDndService.js": [
		2602,
		792
	],
	"./unicodeTextModelHighlighter": [
		9141
	],
	"./unicodeTextModelHighlighter.js": [
		9141
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1890;
module.exports = webpackAsyncContext;